// removed by extract-text-webpack-plugin
module.exports = {"SuggestionsWireframe":"Wireframe__SuggestionsWireframe___3YfxG","Container":"Wireframe__Container___13pUl","SuggestionsTitle":"Wireframe__SuggestionsTitle___2VGpm","Title":"Wireframe__Title___3me9i","Arrows":"Wireframe__Arrows___3N8cY","SuggestionsCards":"Wireframe__SuggestionsCards___2Dcdy","SuggestionsCard":"Wireframe__SuggestionsCard___2QOng"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Main/SuggestionsWireframe/Wireframe.scss
// module id = 1374
// module chunks = 0